import script from "./genTask.vue?vue&type=script&setup=true&lang=ts"
export * from "./genTask.vue?vue&type=script&setup=true&lang=ts"

import "./genTask.vue?vue&type=style&index=0&id=b80a7d88&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b80a7d88"]])

export default __exports__